import * as React from "react";
import { db } from "../../firebase";
import { withAuthorization } from "../../firebase/withAuthorization";
import { TagList } from "../../pills/tags/tagsList";
import { TagAddForm } from "../../pills/tags/tagAddForm";


class TagsComponent extends React.Component {
  constructor(props: any) {
    super(props);

    this.state = {
      tags: null,
      categories: null
    };
    this.handleTagAssign = this.handleTagAssign.bind(this)
    this.handleTagListUpdate = this.handleTagListUpdate.bind(this)
  }

  public componentDidMount() {
    db.onceGetTags().then(snapshot =>
      this.setState(() => ({ tags: snapshot.val() }))
    );
    db.onceGetCategories().then(snapshot =>
      this.setState(() => ({ categories: snapshot.val() }))
    );
  }

  handleTagAssign(){
    db.onceGetTags().then(snapshot =>
      this.setState(() => ({ tags: snapshot.val() }))
    );
    db.onceGetCategories().then(snapshot =>
      this.setState(() => ({ categories: snapshot.val() }))
    );
  }

  handleTagListUpdate() {
    db.onceGetTags().then(snapshot =>
      this.setState(() => ({ tags: snapshot.val() }))
    );
  }
  public render() {
    const {  tags, categories }: any = this.state;

    return (
      <div>       
        <TagAddForm  onTagAdded={this.handleTagListUpdate} />
        <br />
        {!!tags && <TagList onTagDeleted={this.handleTagListUpdate} onhandleTagAssigned={this.handleTagAssign} tags={tags} categories={categories} />}
      </div>
    );
  }
}

const authCondition = (authUser: any) => !!authUser ;

export const TagsPage = withAuthorization(authCondition)(TagsComponent);


// WEBPACK FOOTER //
// ./src/pages/Tags/index.tsx